import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import './Flights.css';

const Flights = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Placeholder flights data
  const allFlights = [
    {
      id: 'FL001',
      flightNumber: 'SF101',
      airline: 'British Airways',
      route: 'Lagos → London',
      departureTime: '14:20',
      arrivalTime: '06:30+1',
      class: 'Business',
      status: 'Active'
    },
    {
      id: 'FL002',
      flightNumber: 'SF102',
      airline: 'Air Peace',
      route: 'Abuja → Lagos',
      departureTime: '10:00',
      arrivalTime: '11:30',
      class: 'Economy',
      status: 'Active'
    },
    {
      id: 'FL003',
      flightNumber: 'SF201',
      airline: 'Emirates',
      route: 'Lagos → Dubai',
      departureTime: '22:15',
      arrivalTime: '08:45+1',
      class: 'First',
      status: 'Active'
    },
    {
      id: 'FL004',
      flightNumber: 'SF103',
      airline: 'Arik Air',
      route: 'Lagos → Accra',
      departureTime: '08:30',
      arrivalTime: '10:00',
      class: 'Economy',
      status: 'Active'
    },
    {
      id: 'FL005',
      flightNumber: 'SF301',
      airline: 'Lufthansa',
      route: 'Lagos → Frankfurt',
      departureTime: '23:00',
      arrivalTime: '06:15+1',
      class: 'Business',
      status: 'Active'
    },
    {
      id: 'FL006',
      flightNumber: 'SF104',
      airline: 'Dana Air',
      route: 'Port Harcourt → Lagos',
      departureTime: '12:00',
      arrivalTime: '13:15',
      class: 'Economy',
      status: 'Cancelled'
    },
    {
      id: 'FL007',
      flightNumber: 'SF202',
      airline: 'Qatar Airways',
      route: 'Abuja → Doha',
      departureTime: '01:30',
      arrivalTime: '09:00+1',
      class: 'Business',
      status: 'Active'
    },
    {
      id: 'FL008',
      flightNumber: 'SF105',
      airline: 'Overland Airways',
      route: 'Kano → Lagos',
      departureTime: '15:45',
      arrivalTime: '17:30',
      class: 'Economy',
      status: 'Active'
    },
    {
      id: 'FL009',
      flightNumber: 'SF401',
      airline: 'Turkish Airlines',
      route: 'Lagos → Istanbul',
      departureTime: '18:00',
      arrivalTime: '04:30+1',
      class: 'Business',
      status: 'Active'
    },
    {
      id: 'FL010',
      flightNumber: 'SF106',
      airline: 'Ibom Air',
      route: 'Uyo → Lagos',
      departureTime: '09:00',
      arrivalTime: '10:45',
      class: 'Economy',
      status: 'Cancelled'
    },
    {
      id: 'FL011',
      flightNumber: 'SF501',
      airline: 'Ethiopian Airlines',
      route: 'Lagos → Addis Ababa',
      departureTime: '20:30',
      arrivalTime: '06:00+1',
      class: 'Business',
      status: 'Active'
    },
    {
      id: 'FL012',
      flightNumber: 'SF107',
      airline: 'Max Air',
      route: 'Abuja → Kano',
      departureTime: '11:30',
      arrivalTime: '12:45',
      class: 'Economy',
      status: 'Active'
    }
  ];

  // Filter flights based on search and filters
  const filteredFlights = allFlights.filter(flight => {
    const matchesSearch = 
      flight.flightNumber.toLowerCase().includes(searchQuery.toLowerCase()) ||
      flight.route.toLowerCase().includes(searchQuery.toLowerCase()) ||
      flight.airline.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesStatus = statusFilter === 'all' || flight.status.toLowerCase() === statusFilter.toLowerCase();
    
    const isDomestic = !flight.route.includes('→') || 
      (flight.route.includes('Lagos') && flight.route.includes('Abuja')) ||
      (flight.route.includes('Lagos') && flight.route.includes('Port Harcourt')) ||
      (flight.route.includes('Lagos') && flight.route.includes('Kano')) ||
      (flight.route.includes('Lagos') && flight.route.includes('Uyo')) ||
      (flight.route.includes('Abuja') && flight.route.includes('Kano'));
    
    const matchesType = typeFilter === 'all' || 
      (typeFilter === 'domestic' && isDomestic) ||
      (typeFilter === 'international' && !isDomestic);
    
    return matchesSearch && matchesStatus && matchesType;
  });

  // Pagination calculations
  const totalPages = Math.ceil(filteredFlights.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedFlights = filteredFlights.slice(startIndex, endIndex);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
    setCurrentPage(1);
  };

  const handleTypeFilterChange = (e) => {
    setTypeFilter(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleAddFlight = () => {
    navigate('/admin/flights/add');
  };

  const handleViewFlight = (flightId) => {
    // Placeholder for view flight
    console.log('View flight:', flightId);
  };

  const handleEditFlight = (flightId) => {
    // Placeholder for edit flight
    console.log('Edit flight:', flightId);
  };

  const handleToggleFlight = (flightId) => {
    // Placeholder for disable/enable flight
    console.log('Toggle flight:', flightId);
  };

  return (
    <AdminLayout pageTitle="Flights">
      <div className="admin-flights-page">
        {/* Page Title */}
        <div className="admin-flights-header">
          <h1 className="admin-flights-title">Flights</h1>
          <p className="admin-flights-subtitle">Manage all available flights</p>
        </div>

        {/* Top Action Bar */}
        <div className="admin-flights-controls">
          <div className="admin-controls-left">
            <button
              className="admin-add-flight-button"
              onClick={handleAddFlight}
            >
              + Add Flight
            </button>
            
            <div className="admin-search-wrapper">
              <input
                type="text"
                className="admin-search-input"
                placeholder="Search by flight number, route, or airline..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
              <span className="admin-search-icon">🔍</span>
            </div>
            
            <select
              className="admin-filter-select"
              value={statusFilter}
              onChange={handleStatusFilterChange}
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="cancelled">Cancelled</option>
            </select>

            <select
              className="admin-filter-select"
              value={typeFilter}
              onChange={handleTypeFilterChange}
            >
              <option value="all">All Types</option>
              <option value="domestic">Domestic</option>
              <option value="international">International</option>
            </select>

            <select className="admin-filter-select">
              <option value="">Date Range</option>
              <option value="today">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
            </select>
          </div>
        </div>

        {/* Flights Table */}
        {paginatedFlights.length > 0 ? (
          <>
            <div className="admin-flights-table-wrapper">
              {/* Desktop Table */}
              <table className="admin-flights-table">
                <thead>
                  <tr>
                    <th>Flight Number</th>
                    <th>Airline</th>
                    <th>Route</th>
                    <th>Departure Time</th>
                    <th>Arrival Time</th>
                    <th>Class</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedFlights.map((flight) => (
                    <tr key={flight.id} className="admin-flights-table-row">
                      <td className="admin-table-cell admin-table-id">{flight.flightNumber}</td>
                      <td className="admin-table-cell">{flight.airline}</td>
                      <td className="admin-table-cell">{flight.route}</td>
                      <td className="admin-table-cell">{flight.departureTime}</td>
                      <td className="admin-table-cell">{flight.arrivalTime}</td>
                      <td className="admin-table-cell">{flight.class}</td>
                      <td className="admin-table-cell">
                        <span className={`admin-status-badge admin-status-${flight.status.toLowerCase()}`}>
                          {flight.status}
                        </span>
                      </td>
                      <td className="admin-table-cell">
                        <div className="admin-actions-menu">
                          <button
                            className="admin-action-button"
                            onClick={() => handleViewFlight(flight.id)}
                          >
                            View
                          </button>
                          <button
                            className="admin-action-button"
                            onClick={() => handleEditFlight(flight.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="admin-action-button"
                            onClick={() => handleToggleFlight(flight.id)}
                          >
                            {flight.status === 'Active' ? 'Disable' : 'Enable'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Mobile Card View */}
              <div className="admin-flights-cards">
                {paginatedFlights.map((flight) => (
                  <div key={flight.id} className="admin-flight-card">
                    <div className="admin-flight-card-header">
                      <div className="admin-flight-card-number">{flight.flightNumber}</div>
                      <span className={`admin-status-badge admin-status-${flight.status.toLowerCase()}`}>
                        {flight.status}
                      </span>
                    </div>
                    <div className="admin-flight-card-body">
                      <div className="admin-flight-card-row">
                        <span className="admin-flight-card-label">Airline:</span>
                        <span className="admin-flight-card-value">{flight.airline}</span>
                      </div>
                      <div className="admin-flight-card-row">
                        <span className="admin-flight-card-label">Route:</span>
                        <span className="admin-flight-card-value">{flight.route}</span>
                      </div>
                      <div className="admin-flight-card-row">
                        <span className="admin-flight-card-label">Departure:</span>
                        <span className="admin-flight-card-value">{flight.departureTime}</span>
                      </div>
                      <div className="admin-flight-card-row">
                        <span className="admin-flight-card-label">Arrival:</span>
                        <span className="admin-flight-card-value">{flight.arrivalTime}</span>
                      </div>
                      <div className="admin-flight-card-row">
                        <span className="admin-flight-card-label">Class:</span>
                        <span className="admin-flight-card-value">{flight.class}</span>
                      </div>
                    </div>
                    <div className="admin-flight-card-actions">
                      <select
                        className="admin-mobile-actions-select"
                        onChange={(e) => {
                          const action = e.target.value;
                          if (action === 'view') handleViewFlight(flight.id);
                          else if (action === 'edit') handleEditFlight(flight.id);
                          else if (action === 'toggle') handleToggleFlight(flight.id);
                          e.target.value = '';
                        }}
                      >
                        <option value="">Actions...</option>
                        <option value="view">View</option>
                        <option value="edit">Edit</option>
                        <option value="toggle">{flight.status === 'Active' ? 'Disable' : 'Enable'}</option>
                      </select>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Pagination */}
            <div className="admin-pagination">
              <div className="admin-pagination-info">
                Showing {startIndex + 1} to {Math.min(endIndex, filteredFlights.length)} of {filteredFlights.length} flights
              </div>
              <div className="admin-pagination-controls">
                <select
                  className="admin-rows-select"
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                  <option value={100}>100 per page</option>
                </select>
                <div className="admin-page-numbers">
                  <button
                    className="admin-page-button"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(page => {
                      return page === 1 || 
                             page === totalPages || 
                             (page >= currentPage - 1 && page <= currentPage + 1);
                    })
                    .map((page, index, array) => {
                      const prevPage = array[index - 1];
                      const showEllipsis = prevPage && page - prevPage > 1;
                      
                      return (
                        <React.Fragment key={page}>
                          {showEllipsis && <span className="admin-page-ellipsis">...</span>}
                          <button
                            className={`admin-page-button ${currentPage === page ? 'active' : ''}`}
                            onClick={() => handlePageChange(page)}
                          >
                            {page}
                          </button>
                        </React.Fragment>
                      );
                    })}
                  <button
                    className="admin-page-button"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          /* Empty State */
          <div className="admin-empty-state">
            <div className="admin-empty-icon">✈️</div>
            <h3 className="admin-empty-title">No flights available</h3>
            <p className="admin-empty-text">
              {searchQuery || statusFilter !== 'all' || typeFilter !== 'all'
                ? 'Try adjusting your search or filters' 
                : 'Get started by adding your first flight'}
            </p>
            <button
              className="admin-empty-action-button"
              onClick={handleAddFlight}
            >
              + Add Flight
            </button>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default Flights;

